import { SEARCH_TEST_ID } from '../../test/test-ids';

export const DefaultPreventedLinkElement = ({ onClick, children, ...props }) => (
    <a
        {...props}
        onClick={(event) => {
            event.preventDefault();
            onClick?.(event);
        }}
        data-test={SEARCH_TEST_ID.PAGINATION_LINK}
    >
        {children}
    </a>
);
